window.addEventListener("load", (e) =>{
    function handlePricePDP() {
        if (document.querySelector(".productView-price .bsscommerce-ltsp-message")) return;
        let priceElement = document.querySelector(".productView-price span");
        if (!priceElement) return;
        let price = priceElement.textContent.trim();
        price = price.replace(/[^\d]/g, "");
        let quantityElement = document.querySelector(".quantity__input");
        if (!quantityElement) return;
        const qty = parseInt(quantityElement.value, 10) || 0;
        const subtotal = qty * parseFloat(price);
        let subtotalElement = document.querySelector(".productView-subtotal .money-subtotal");
        if (subtotalElement) {
            subtotalElement.textContent = BSS_B2B.formatMoney(subtotal * 100);
            subtotalElement.style.opacity = "1";
        }
    }

    setTimeout(() =>{
        handlePricePDP();
    },
    1000);

    const quantityButtons = document.querySelectorAll(".halo-productView-right .btn-quantity");
    quantityButtons.forEach((button) =>{
        button.addEventListener("click", (e) =>{
            handlePricePDP();
        });
    });

});

function handlePriceQuickView() {
    let priceElementQuickView = document.querySelector(".productView-price span");
    let priceQuickView = priceElementQuickView.textContent.trim();
    priceQuickView = priceQuickView.replace(/[^\d]/g, "");
    let quantityElementQuickView = document.querySelector(".quantity__input");
    const qtyQuickView = parseInt(quantityElementQuickView.value, 10) || 0;
    const subtotalQuickView = qtyQuickView * parseFloat(priceQuickView);
    let subtotalElementQuickView = document.querySelector(".productView-subtotal .money-subtotal");
    if (subtotalElementQuickView) {
        subtotalElementQuickView.textContent = BSS_B2B.formatMoney(subtotalQuickView * 100);
        subtotalElementQuickView.style.opacity = "1";
    }
}

setTimeout(() =>{
    const checkoutButton = document.querySelector(".button.button-1.button-checkout");
    const newButton = checkoutButton.cloneNode(true);
    checkoutButton.parentNode.replaceChild(newButton, checkoutButton);
    newButton.addEventListener("click", (e) => {
       e.preventDefault();
       e.stopPropagation();
       e.stopImmediatePropagation();
       BSS_B2B.observer.cartSubject.notifyObserver('CartCheckout', 'ClickCheckout');
    });
},
1000);

setTimeout(() =>{
    const observer = new MutationObserver( async (MutationList) =>{
        for (let item of MutationList) {
            if (item.target.className === "halo-popup-content halo-popup-scroll custom-scrollbar") {
                document.dispatchEvent(new Event(`bss_b2b:QuickviewLoaded`));
                BSS_B2B.observer.productSubject.notifyObserver("ProductMutate", "ProductPriceMutate");
                setTimeout(() =>{
                    handlePriceQuickView()
                },
                800);
                const quantityButtons = document.querySelectorAll(".halo-productView-right .btn-quantity");
                quantityButtons.forEach((button) =>{
                    button.addEventListener("click", (e) =>{
                        handlePriceQuickView();
                    });
                });
              const res = await BSS_B2B.storage.productStorage.load();
              if(res && (res.notExistProductIds?.length || res.productIds?.length || res.variantIds?.size)) {
                   BSS_B2B.observer.productSubject.notifyObserver('LazyProduct', 'LoadedLazyProduct', {
                 ...res,
                });
              }
            }
            if(item.target.className === 'productView-price no-js-hidden clearfix'){
                setTimeout(() =>{
                    handlePriceQuickView()
                },
                800);
            }
        }
    });
    observer.observe(document.body, {
        childList: true,
        subtree: true,
    });
},
300);